'use client';
import styled from 'styled-components';

export const Message = styled.div`
  text-align: center;
  margin-bottom: ${({ theme }) => theme.spacing(14)};
`;

export const Headline = styled.h2`
  ${({ theme }) => theme.typography.subheading1}
  margin-bottom: ${({ theme }) => theme.spacing(2)};
`;

export const Text = styled.p`
  ${({ theme }) => theme.typography.heading3}
`;
